/* AVCF Caelus 360 Galerie v4 (02.11.2026): weicher Übergang Loader -> Uhr, Loader-Animation ruht wenn unsichtbar.
   v3 (31.10.2026). 360 ist die erste Folie und bleibt beim Wischen erhalten, nur X schließt sie.
   v2: Fotos als Swipe-Slider (folgt dem Finger, wie Cainte), 360-Ansicht im iframe (Caelus FINAL Viewer).
   Neu in v2: gezippte Dateien (-gz.bin, Entpacken im Browser), 360 Dateien werden nach dem Seitenladen leise vorgeholt,
   Uhr blendet erst ein, wenn sie flüssig läuft, Rendern pausiert hinter den Fotos.
   03.11.2026: Texte der 360 Ansicht in DE/FR/ES/IT (i18n, nach html lang).
   v7 (03.11.2026): Absturz-Schutz Handy. Grafikspeicher wird beim Schließen (Handy), Seitenwechsel, Farbwechsel
   und Entfernen der Galerie sofort freigegeben (loseContext + iframe weg). Jedes Öffnen läuft wie das erste.
   Grafik verloren: einmal still neu laden, sonst Fehler mit Erneut versuchen (360 Knopf bleibt).
   v8 (03.11.2026): Eine Uhr pro Seite, wird nie doppelt gebaut. X pausiert nur (auch Handy), Wiederöffnen sofort und flüssig,
   beliebig oft ohne neuen Speicher. Freigabe nur beim Verlassen der Seite, Entfernen der Galerie oder Grafikverlust.
   Zusammen mit Viewer v16 (Handy-Speicher ca. 30 % weniger, gleiche Bildqualität).
   v8.1 (03.11.2026): Texturen wieder in voller Originalgröße (4096) auch am Handy (m.tex 0), Details 1:1 wie Original.
   v8.2 (03.11.2026): Zolten und Zolten Arabic am Handy ohne Glanz-Weichzeichner (spf 0): polierte Fasen, Indizes und Zeiger glänzen
   auch in der normalen Ansicht wie am PC, nicht erst beim Zoomen. Caelus unverändert.
   v8.3 (03.11.2026): Zolten Viewer v17: Weichzeichner nur während Bewegung (Intro, Drehen) gegen Funkeln, in Ruhe voller Glanz.
   v8.4 (03.11.2026): Zolten Viewer v19: Weichzeichner folgt der Drehgeschwindigkeit, Glanz kommt schon während das Intro ausrollt.
   v8.5 (03.11.2026): Viewer v20 (Startbild gleich wie Intro, kein Glanzwechsel beim Einblenden). Vergleich: ?av360=sharp = immer voller Glanz.
   v8.6 (03.11.2026): Viewer v21 (alle Uhren): Speicherfreigabe erst in Ruhe, kein Ruckeln im Intro, kein Glanzsprung nach Rucklern.
   v8.7 (03.11.2026): Viewer v22: alle Texturen werden vor dem Einblenden auf die Grafikkarte geladen, nichts lädt sichtbar nach.
   v8.8 (03.11.2026): Zolten und Zolten Arabic: Glanz-Weichzeichner ganz aus (spf 0). Die Uhr sieht in Bewegung und in Ruhe exakt gleich aus. */
(function () {
  if (customElements.get('avcf-gallery')) return;
  const canGz = typeof DecompressionStream !== 'undefined';
  const idle = fn => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 3000 }) : setTimeout(fn, 1500));
  const webgl = () => { try { const c = document.createElement('canvas'), x = c.getContext('webgl2') || c.getContext('webgl'); if (!x) return false; const l = x.getExtension('WEBGL_lose_context'); if (l) l.loseContext(); return true; } catch (e) { return false; } };
  // 0 Knopf, 1 Hinweis PC, 2 Hinweis Handy, 3 Fehler, 4 Erneut, 5-8 Bedienhilfen (aria)
  const AVT = {
    de: ['360° ANSICHT', 'ZIEHEN ZUM DREHEN · SCROLLEN ZUM ZOOMEN', 'ZIEHEN ZUM DREHEN · ZWEI FINGER ZUM ZOOMEN', 'Die 360° Ansicht konnte nicht geladen werden.', 'Erneut versuchen', '360° Ansicht öffnen', '360° Ansicht schließen', 'Vorheriges Bild', 'Nächstes Bild'],
    fr: ['VUE 360°', 'GLISSEZ POUR TOURNER · DÉFILEZ POUR ZOOMER', 'GLISSEZ POUR TOURNER · PINCEZ POUR ZOOMER', 'La vue 360° n’a pas pu être chargée.', 'Réessayer', 'Ouvrir la vue 360°', 'Fermer la vue 360°', 'Image précédente', 'Image suivante'],
    es: ['VISTA 360°', 'ARRASTRA PARA GIRAR · DESPLAZA PARA AMPLIAR', 'ARRASTRA PARA GIRAR · PELLIZCA PARA AMPLIAR', 'No se pudo cargar la vista 360°.', 'Reintentar', 'Abrir vista 360°', 'Cerrar vista 360°', 'Imagen anterior', 'Imagen siguiente'],
    it: ['VISTA 360°', 'TRASCINA PER RUOTARE · SCORRI PER INGRANDIRE', 'TRASCINA PER RUOTARE · PIZZICA PER INGRANDIRE', 'Impossibile caricare la vista a 360°.', 'Riprova', 'Apri la vista a 360°', 'Chiudi la vista a 360°', 'Immagine precedente', 'Immagine successiva']
  };

  // Läuft im iframe vor dem Viewer: Pause für das Rendern, Messung der Bildrate, Entpacken der -gz.bin Dateien
  function inFrame() {
    var R = window.requestAnimationFrame.bind(window), q = [], ft = [];
    window.__avcPause = false; window.__avcDead = false;
    var GL = window.__avcGL = [], gc = HTMLCanvasElement.prototype.getContext;
    HTMLCanvasElement.prototype.getContext = function (t, o) { var c = gc.call(this, t, o); if (c && /webgl/.test(t) && GL.indexOf(c) < 0) GL.push(c); return c; };
    // v7: Grafikspeicher sofort freigeben (iOS gibt ihn sonst erst spät frei, mehrere Uhren = Absturz)
    window.__avcKill = function () { window.__avcDead = true; window.__avcPause = true; q = []; GL.forEach(function (g) { try { var l = g.getExtension('WEBGL_lose_context'); if (l && !g.isContextLost()) l.loseContext(); } catch (e) {} }); GL.length = 0; };
    window.requestAnimationFrame = function (cb) {
      if (window.__avcPause) { q.push(cb); return 0; }
      return R(function (t) { ft.push(t); if (ft.length > 16) ft.shift(); cb(t); });
    };
    window.__avcResume = function () { window.__avcPause = false; var a = q; q = []; a.forEach(function (cb) { window.requestAnimationFrame(cb); }); };
    window.__avcSmooth = function () { var u = []; for (var i = 1; i < ft.length; i++) if (ft[i] !== ft[i - 1]) u.push(ft[i] - ft[i - 1]); if (u.length < 5) return false; for (var k = u.length - 5; k < u.length; k++) if (u[k] > 50) return false; return true; };
    var F = window.fetch.bind(window);
    window.fetch = function (i, o) {
      var u = typeof i === 'string' ? i : (i && i.url) || '';
      if (!/-gz\.bin/.test(u)) return F(i, o);
      return F(i, o).then(function (r) { if (!r.ok) return r; return new Response(r.body.pipeThrough(new DecompressionStream('gzip')), { status: 200, headers: { 'Content-Type': 'application/octet-stream' } }); });
    };
    document.addEventListener('webglcontextlost', function () { if (!window.__avcDead) parent.postMessage({ avc: 'lost' }, '*'); }, true);
    document.addEventListener('pointerdown', function () { parent.postMessage({ avc: 'touch' }, '*'); }, { once: true });
    document.addEventListener('wheel', function () { parent.postMessage({ avc: 'touch' }, '*'); }, { once: true, passive: true });
  }

  class AvcfGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) { this.bind(true); return; } this._init = true;
      this.lite = matchMedia('(pointer:coarse)').matches; this.lostN = 0; // Handy/Tablet
      this.$ = s => this.querySelector(s);
      this.i18n();
      const cj = this.$('.avcf__cfg'); this.cfg = cj ? JSON.parse(cj.textContent) : null; // ohne cfg: nur Fotos/Videos (Produkte ohne 360)
      // v8: Viewer v16 (Handy-Speicher, gleiche Bildqualität) unter eigenem Dateinamen. Nur dieses Theme nutzt ihn, das Live-Theme bleibt bis zum Veröffentlichen unverändert
      if (this.cfg && this.cfg.urls && this.cfg.urls.viewer) this.cfg.urls.viewer = this.cfg.urls.viewer.replace(/\/(avcf4|zav1|zaa1)-viewer(-gz)?\.bin(\?.*)?$/, (m, a, g) => '/' + { avcf4: 'avcf22', zav1: 'zav22', zaa1: 'zaa22' }[a] + '-viewer' + (g || '') + '.bin');
      this.track = this.$('.avcf__track');
      this.slides = [...this.querySelectorAll('.avcf__slide')];
      this.thumbs = [...this.querySelectorAll('.avcf__thumb')];
      this.tbox = this.$('.avcf__thumbs');
      this.box = this.$('.avcf__3d'); this.loader = this.$('.avcf__loader'); this.loader.hidden = false;
      this.n = this.slides.length; this.idx = 0; this.loaded = false; this.target = null;
      this.no3d = !this.cfg || !webgl(); // ohne cfg oder WebGL kein 360 Knopf
      if (!canGz && this.cfg) Object.keys(this.cfg.urls).forEach(k => { const v = this.cfg.urls[k]; if (/-gz\.bin/.test(v)) this.cfg.urls[k] = v.split('?')[0].replace('avcf2-', 'avcf1-').replace('-gz.bin', '.bin'); }); // ältere Browser: ungezippte Dateien
      this.s3 = 'off'; // 360 auf Folie 1: off | loading | on
      this.slide0 = this.slides[0];
      if (this.slide0) { this.slide0.append(this.box, this.loader, this.$('.avcf__error')); }

      this.thumbs.forEach(t => t.addEventListener('click', () => this.go(+t.dataset.i)));
      this.$('.avcf__arrow--prev').addEventListener('click', () => this.go(this.idx - 1));
      this.$('.avcf__arrow--next').addEventListener('click', () => this.go(this.idx + 1));
      this.$('.avcf__pill').addEventListener('click', () => this.open360());
      this.$('.avcf__close').addEventListener('click', () => this.close3d());
      this.$('.avcf__retry').addEventListener('click', () => { this.$('.avcf__error').hidden = true; this.reset3d(); this.s3 = 'off'; this.lostN = 0; this.open360(); });
      const pill = this.$('.avcf__pill'); if (!this.no3d) pill.classList.add('is-intro'); setTimeout(() => pill.classList.remove('is-intro'), 6200);

      // Aktuelles Foto aus der Scroll-Position (Finger, Trackpad, Pfeile)
      this.track.addEventListener('scroll', () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          const w = this.track.clientWidth || 1, i = Math.max(0, Math.min(this.n - 1, Math.round(this.track.scrollLeft / w)));
          if (this.target !== null) { if (i !== this.target) return; this.target = null; }
          if (i !== this.idx) { this.idx = i; this.onSlide(); this.ui(); this.syncThumb(); }
        });
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(() => { if (this.target === null) this.track.scrollTo({ left: this.idx * this.track.clientWidth, behavior: 'instant' }); }).observe(this.track);
      this.bind(true);
      this.ui();

      const later = () => {
        this.slides.forEach(s => { const im = s.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; }); // kein grauer Blitz beim Wischen
        setTimeout(() => this.prefetch(), 1200);
      };
      if (document.readyState === 'complete') idle(later); else window.addEventListener('load', () => idle(later), { once: true });
    }

    disconnectedCallback() { this.bind(false); this.stop3d(); } // Galerie ersetzt (z.B. andere Farbe ohne Neuladen): Grafik freigeben
    // Globale Ereignisse nur solange die Galerie im Dokument ist
    bind(on) {
      if (!!this._bound === on) return; this._bound = on;
      const h = this._h || (this._h = {
        msg: e => this.onMsg(e),
        vc: e => this.onVariant(e),
        hide: () => this.stop3d(), // Seite verlassen / Zurück-Cache: Grafik sofort freigeben
        vis: () => { if (document.hidden) this.pause3d(true); else if (this.s3 !== 'off' && this.idx === 0) this.pause3d(false); }
      });
      const m = on ? 'addEventListener' : 'removeEventListener';
      window[m]('message', h.msg); document[m]('variant:change', h.vc); window[m]('pagehide', h.hide); document[m]('visibilitychange', h.vis);
    }
    // Variante gewechselt (z.B. Gold/Silber): zum Bild der Variante springen, wie die Prestige Galerie
    onVariant(e) { const m = e.detail && e.detail.variant && e.detail.variant.featured_media; if (!m || !this.isConnected) return; const k = this.slides.findIndex(x => x.dataset.mediaId === String(m.id)); if (k >= 0 && k !== this.idx) this.go(k); }
    // 360 schließen und Grafik ganz freigeben
    stop3d() { if (this.s3 !== 'off') this.close3d(); this.kill3d(); this.ui(); }
    // Grafikspeicher freigeben und iframe entfernen; nächstes Öffnen lädt neu (Dateien kommen aus dem Browser-Cache)
    kill3d() {
      const f = this.frame; this.frame = null; this.loaded = false;
      this.clrRv(); clearTimeout(this.to); clearInterval(this.poll); clearTimeout(this._p3); clearTimeout(this._kt);
      if (f) { try { const w = f.contentWindow; if (w && w.__avcKill) w.__avcKill(); } catch (e) {} f.remove(); }
      this.box.classList.remove('is-on', 'is-load'); this.box.hidden = true;
    }

    // Texte der 360 Ansicht in der Shop-Sprache (Englisch bleibt wie im Snippet)
    i18n() {
      const T = AVT[(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()];
      if (!T) return;
      const set = (s, v) => { const e = this.$(s); if (e) e.textContent = v; };
      const aria = (s, v) => { const e = this.$(s); if (e) e.setAttribute('aria-label', v); };
      set('.avcf__pill span', T[0]); set('.avcf__hint-pc', T[1]); set('.avcf__hint-m', T[2]);
      const er = this.$('.avcf__error'); if (er && er.firstChild && er.firstChild.nodeType === 3) er.firstChild.textContent = T[3] + ' ';
      set('.avcf__retry', T[4]);
      aria('.avcf__pill', T[5]); aria('.avcf__close', T[6]); aria('.avcf__arrow--prev', T[7]); aria('.avcf__arrow--next', T[8]);
    }

    // 360 Dateien leise in den Browser-Cache holen: nur auf dieser Seite, nach dem Laden, nacheinander, niedrige Priorität, nicht bei Datensparen/langsamer Verbindung
    prefetch() {
      if (this.no3d || this._pf || this.frame) return;
      const c = navigator.connection;
      if (c && (c.saveData || /2g|3g/.test(c.effectiveType || ''))) return;
      this._pf = true;
      const u = this.cfg.urls;
      // Modelle per fetch, Texturen als Bild (Shopify liefert Bilder je nach Anfrage anders aus, nur so trifft der Viewer den Cache)
      const list = [this.cfg.frame].concat(Object.keys(u).filter(k => k.indexOf('tx-') !== 0).map(k => u[k])).map(x => ['f', x])
        .concat(Object.keys(u).filter(k => k.indexOf('tx-') === 0).map(k => ['i', u[k]]));
      let k = 0;
      const next = () => {
        if (k >= list.length || this.frame) return;
        const [t, x] = list[k++], go = () => setTimeout(next, 60);
        if (t === 'i') { const im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async'; im.onload = im.onerror = go; im.src = x; }
        else fetch(x, { priority: 'low' }).then(r => r.arrayBuffer()).catch(() => {}).then(go);
      };
      next();
    }

    go(i) {
      i = Math.max(0, Math.min(this.n - 1, i));
      this.idx = i; this.target = i;
      clearTimeout(this._tt); this._tt = setTimeout(() => { this.target = null; }, 900);
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
      this.onSlide(); this.ui(); this.syncThumb();
    }
    // 360 nur rendern, wenn Folie 1 sichtbar ist (spart Akku), Zustand bleibt erhalten
    onSlide() {
      this.vids(); if (this.s3 === 'off') return;
      clearTimeout(this._p3);
      if (this.idx === 0) this.pause3d(false);
      else this._p3 = setTimeout(() => { if (this.idx !== 0) this.pause3d(true); }, 450);
    }
    // Videos: nur das sichtbare spielt (stumm, Schleife)
    vids() { this.slides.forEach((s, k) => { const v = s.querySelector('video'); if (!v) return; if (k === this.idx) { v.muted = true; v.playsInline = true; const p = v.play(); if (p) p.catch(() => {}); } else v.pause(); }); }
    syncThumb() {
      const t = this.thumbs[this.idx], b = this.tbox; if (!t || !b) return;
      const br = b.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (b.scrollWidth > b.clientWidth + 1) {
        if (tr.left < br.left + 20 || tr.right > br.right - 20) b.scrollTo({ left: b.scrollLeft + (tr.left - br.left) - (br.width - tr.width) / 2, behavior: 'smooth' });
      } else if (b.scrollHeight > b.clientHeight + 1) {
        if (tr.top < br.top || tr.bottom > br.bottom) b.scrollTo({ top: b.scrollTop + (tr.top - br.top) - (br.height - tr.height) / 2, behavior: 'smooth' });
      }
    }
    ui() {
      const on0 = this.idx === 0, act = this.s3 !== 'off', d = on0 && this.s3 === 'on';
      this.thumbs.forEach((t, k) => t.setAttribute('aria-current', k === this.idx ? 'true' : 'false'));
      if (this.thumbs[0]) this.thumbs[0].classList.toggle('is-360', act);
      this.$('.avcf__pill').hidden = this.no3d || (on0 && act); this.$('.avcf__close').hidden = !(on0 && act);
      this.$('.avcf__icon360').hidden = !d; this.$('.avcf__hint').hidden = !d || this.hinted;
      this.$('.avcf__arrow--prev').hidden = this.idx === 0;
      this.$('.avcf__arrow--next').hidden = this.idx >= this.n - 1;
    }
    open360() {
      if (this.no3d) return;
      if (this.idx !== 0) this.go(0);
      if (this.s3 !== 'off') return;
      this.slide0.classList.add('is-3d');
      if (this.loaded) { this.show3d(); return; }
      this.s3 = 'loading'; this.t0 = performance.now();
      this.loader.classList.add('is-on'); this.box.hidden = false; this.box.classList.add('is-load'); this.ui();
      if (!this.frame) this.build(); else this.pause3d(false);
    }
    build() {
      const f = document.createElement('iframe');
      f.title = (this.cfg.title || 'Watch') + ' 360 view'; f.setAttribute('allow', 'fullscreen');
      this.frame = f; this.box.hidden = false; this.box.appendChild(f);
      fetch(this.cfg.frame).then(r => { if (!r.ok) throw new Error('frame ' + r.status); return r.text(); }).then(t => {
        if (t.charAt(0) === '{') t = JSON.parse(t).html;
        const o = { color: this.cfg.color, urls: this.cfg.urls, intro: this.cfg.intro || { a: 0.7, dur: 2600, ease: 'out' }, m: Object.assign({ tex: 0 }, this.cfg.m || {}) };
        // v8.8: Zolten und Zolten Arabic immer voller Glanz, ein einziger Zustand. Kein Wechsel zwischen Bewegung und Stillstand.
        if (/\/(zav|zaa)\d+-viewer/.test((this.cfg.urls && this.cfg.urls.viewer) || '') && !/[?&]av360=soft/.test(location.search)) o.spf = 0;
        const c = JSON.stringify(o).replace(/</g, '\\u003c');
        const inj = '<script>window.AVC_CFG=' + c + ';(' + inFrame.toString() + ')();<\/script>';
        f.srcdoc = t.replace('<!--AVC_CFG-->', () => inj);
      }).catch(e => this.fail(e));
      this.to = setTimeout(() => { if (!this.loaded) this.fail(new Error('timeout')); }, 60000);
      // Viewer meldet Fehler nur im eigenen DOM (#retry sichtbar): sofort erkennen
      this.poll = setInterval(() => { try { const r = f.contentDocument && f.contentDocument.querySelector('#retry'); if (r && !r.hidden) { clearInterval(this.poll); this.fail(new Error('viewer')); } } catch (e) {} }, 500);
    }
    onMsg(e) {
      if (!this.frame || e.source !== this.frame.contentWindow || !e.data || !e.data.avc) return;
      if (e.data.avc === 'ready') {
        this.loaded = true; clearTimeout(this.to); clearInterval(this.poll);
        // erst einblenden, wenn die Uhr flüssig läuft (max. 1,5 s warten) und der Loader nicht nur aufblitzt (min. 0,7 s)
        const w = this.frame.contentWindow, t1 = performance.now();
        const check = () => {
          if (this.s3 !== 'loading') return;
          let ok = false; try { ok = w.__avcSmooth(); } catch (er) { ok = true; }
          const now = performance.now();
          if ((ok || now - t1 > 1500) && now - this.t0 > 700) this.show3d(); else setTimeout(check, 50);
        };
        check();
      } else if (e.data.avc === 'touch') { this.hinted = true; this.ui(); }
      else if (e.data.avc === 'error' && !this.loaded) this.fail(new Error(e.data.msg));
      // v7 Grafik verloren (iOS bei Speicherdruck): freigeben, einmal still neu laden, sonst Fehler mit Erneut versuchen
      else if (e.data.avc === 'lost') {
        const was = this.s3; this.kill3d(); this.lostN++;
        if (was === 'off') { this.ui(); return; }
        this.s3 = 'off';
        if (this.lostN <= 1) { this.open360(); return; }
        this.s3 = 'loading'; this.slide0.classList.add('is-3d'); this.loader.classList.remove('is-on'); this.ui(); this.fail(new Error('lost'));
      }
    }
    // v4: Übergang Loader -> Uhr in Stufen. Uhr steht still (Handy bleibt bei 60 fps), Symbol blendet aus,
    // dann der Hintergrund, die Uhr setzt sich leicht, erst danach dreht sie. Kein stehengebliebenes Symbol mehr.
    show3d() {
      const L = this.loader, fromLoader = L.classList.contains('is-on');
      this.s3 = 'on'; this.slide0.classList.add('is-3d'); this.box.hidden = false;
      if (!fromLoader) {
        this.onSlide(); this.ui();
        requestAnimationFrame(() => { this.box.classList.add('is-on'); this.box.classList.remove('is-load'); });
        return;
      }
      this.clrRv(); this.pause3d(true);
      this.box.classList.add('is-on'); this.box.classList.remove('is-load');
      const E = 'cubic-bezier(.4,0,.2,1)', calm = matchMedia('(prefers-reduced-motion:reduce)').matches;
      const ic = L.querySelector('.avcf__cupid');
      L.classList.add('is-out');
      if (ic && ic.animate) this._icA = ic.animate([{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.94)' }], { duration: calm ? 1 : 300, easing: E, fill: 'forwards' });
      this._rv = [
        setTimeout(() => {
          L.classList.remove('is-on');
          if (this.s3 === 'on') { this.onSlide(); this.intro(calm); } // v14: Drehung startet sofort mit dem Ausblenden, keine Wartezeit
        }, calm ? 0 : 180),
        setTimeout(() => { this.clrRv(); if (this.s3 === 'on') this.ui(); }, calm ? 60 : 860)
      ];
    }
    // v13 Viewer: Uhr dreht von der Seite weich auf frontal (wie Cartier), startet erst nach dem Einblenden
    intro(fast) { try { const w = this.frame && this.frame.contentWindow; if (w && w.__avcIntro) w.__avcIntro(fast); } catch (e) {} }
    clrRv() {
      (this._rv || []).forEach(clearTimeout); this._rv = null;
      if (this._icA) { this._icA.cancel(); this._icA = null; }
      if (this._frA) { this._frA.cancel(); this._frA = null; }
      this.loader.classList.remove('is-out');
    }
    close3d() {
      this.s3 = 'off'; this.slide0.classList.remove('is-3d'); this.clrRv();
      this.box.classList.remove('is-on', 'is-load'); this.loader.classList.remove('is-on'); this.$('.avcf__error').hidden = true;
      clearTimeout(this._p3); clearTimeout(this._kt);
      // v8: immer nur pausieren, auch beim Laden (eine Uhr pro Seite, nie doppelt im Speicher). Wiederöffnen sofort bzw. lädt weiter
      this._p3 = setTimeout(() => { if (this.s3 === 'off') this.pause3d(true); }, 500);
      this.ui();
    }
    pause3d(on) { try { const w = this.frame && this.frame.contentWindow; if (!w || !w.__avcResume) return; if (on) w.__avcPause = true; else w.__avcResume(); } catch (e) {} }
    fail(err) {
      if (window.console) console.warn('avcf 360', err && err.message);
      clearTimeout(this.to); clearInterval(this.poll);
      if (this.s3 !== 'loading') return;
      this.clrRv(); this.loader.classList.remove('is-on'); this.$('.avcf__error').hidden = false;
    }
    reset3d() { this.kill3d(); }
  }
  customElements.define('avcf-gallery', AvcfGallery);
})();
